import { render, staticRenderFns } from "./_defaultTemplate.vue?vue&type=template&id=551afdd0&lang=pug"
import script from "./_defaultTemplate.vue?vue&type=script&lang=js"
export * from "./_defaultTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports